<template>
    <div><!--ini -->

        <v-breadcrumbs :items="items" large></v-breadcrumbs>

        <v-card>
            <v-row>
                <v-col cols="3 " >
                    <v-col cols="12">
                        <v-text-field label="Nombre de la Evaluaciòn"  v-model="nombre" :rules="nameRules" ></v-text-field>
                    </v-col>
                </v-col>

                <v-col cols="3 " >
                    <v-col cols="12">
                        <v-text-field label="Objetivo de la Evaluaciòn"  v-model="nombre" :rules="nameRules" ></v-text-field>
                    </v-col>
                </v-col>

                <v-col cols="3 " >
                    <v-col cols="12">
                        <v-text-field label="Herramientas de Evaluaciòn"  v-model="nombre" :rules="nameRules" ></v-text-field>
                    </v-col>
                </v-col>

                <v-col cols="3 " >
                    <v-col cols="12">
                        <v-select
                            @change="getAllGradosAdmin(id_nivel)"
                            :items="NivelesAdmin"
                            v-model="id_nivel"
                            item-text="desc_nivel"
                            item-value="id_nivel_adm_nivel"
                            label="Selecciona tipo de prueba"
                            single-line
                            prepend-icon="fa-layer-group"
                        ></v-select>
                    </v-col>
                </v-col>

                <div>
                    <v-btn class="btn_block_style2 ma-5" dark  >Cancelar</v-btn>
                    <v-btn class="btn_block_style2 ma-2" dark  @click="saveItem">Guardar</v-btn>
                </div>
            </v-row>
        </v-card>


    </div>
</template>




<script>
    import { mapMutations} from 'vuex';
    export default {
    name: 'cabeceragestionevaluativa',

    data() {
        return {

            nombre: '',

            items: [
                {
                    text: 'Inicial',
                    disabled: false,
                    href: 'breadcrumbs_dashboard',
                },
                {
                    text: 'Matematica',
                    disabled: false,
                    href: 'breadcrumbs_link_1',
                },
                {
                    text: 'Matematica ini',
                    disabled: false,
                    href: 'breadcrumbs_link_1',
                },
                {
                    text: '5 años',
                    disabled: true,
                    href: 'breadcrumbs_link_2',
                },
            ],

        };

  },

  mounted() {

    },

  methods: {
      ...mapMutations('gestEvaluacion', ['nextWizard', 'backWizard']),


      saveItem(){




      }





    },

  components: {

  }
}
</script>




